import IcWarning from '@/assets/svg/ic-warning.svg?inline'
import IcClose2 from '@/assets/svg/ic-close-2.svg?inline'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'encashmentNotification',
  props: {
    amount: {
      type: Number,
      default: 0
    }
  },
  components: {
    IcWarning,
    IcClose2
  },
  data() {
    return {
      isShow: true
    }
  },
  computed: {
    formatAmount() {
      return numberWithSeparator(this.amount)
    }
  },
  mounted() {
    window.addEventListener('click', this.onClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.onClickOutside)
  },
  methods: {
    onClickOutside(e) {
      if (this.$refs['encashment-notification'].contains(e.target)) {
        return
      }
      this.isShow = false
    }
  }
}